import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Badge,
} from "reactstrap";
import Avatar from 'react-avatar';

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../withRouter";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";
import { logoutUser } from "../../../store/actions";

const ProfileMenu = (props) => {
  const { currentProfile } = props;
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();
  const [username, setusername] = useState("Admin");

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.username);
      }
    }
  }, [props.success]);


  const handleLogOut = () => {
    props.logoutUser();
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <Avatar className='fw-bold' name={props.currentProfile.userName} size={30} round />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end" style={{ minWidth: "300px" }}>
          <DropdownItem>
            <h4 className="text-uppercase"> {props.currentProfile.userName}&nbsp;</h4>
            <Badge color='primary' className='p-2'>
              {props.currentProfile && props.currentProfile.roles && props.currentProfile.roles[0].roleDisplayName}
            </Badge>
          </DropdownItem>
          <DropdownItem divider />
          <Link
            style={{ textDecoration: 'none', color: 'black' }}
            to={`/userlist/details/${currentProfile.roles && currentProfile.roles.length > 0 ? currentProfile.roles[0].userId : ''}`}
          >
            <DropdownItem className="fs-5 text-dark">
              <i className="fa fa-user pe-4" aria-hidden="true"></i>
              My Profile
            </DropdownItem>
          </Link>
          <DropdownItem divider />
          <DropdownItem>
            <Button
              className="text-center fw-bold"
              size='sm'
              style={{ paddingLeft: 13, textDecoration: 'none' }}
              onClick={handleLogOut}
              color='danger'
            >
              Log Out
            </Button>
          </DropdownItem>
          <DropdownItem />
        </DropdownMenu>
      </Dropdown >
    </React.Fragment >
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};



const mapStatetoProps = state => {
  const { error, success } = state.profile;
  const { currentProfile } = state.login;
  return { error, success, currentProfile };
};
const mapDispatchToProps = (dispatch: any) => ({
  logoutUser: () => dispatch(logoutUser()),
});

export default withRouter(
  connect(mapStatetoProps, mapDispatchToProps)(withTranslation()(ProfileMenu))
);
